// Flag global para indicar que estamos en medio de un fetch de filtros
var blsIsRendering = false;

(function waitForBls() {
  if (typeof BlsEventCollectionShopify === "undefined") {
    return setTimeout(waitForBls, 50);
  }

  let openFilterNames = new Set();

  // Reabrir sidebar si se cierra durante un fetch
  const originalSetup = BlsEventCollectionShopify.setupEventListeners.bind(BlsEventCollectionShopify);

  BlsEventCollectionShopify.setupEventListeners = function () {
    originalSetup();

    document.body.addEventListener("click", function (e) {
      if (!blsIsRendering) return;

      const sidebar = document.querySelector("#CollectionSidebar");
      if (sidebar && !sidebar.classList.contains("bls__opend-popup")) {
        sidebar.classList.add("bls__opend-popup");
        document.documentElement.classList.add("hside_opened");
        const overlay = document.querySelector(".bls__overlay");
        const btnFilter = document.querySelector(".collection-filter .btn-filter");
        if (overlay) overlay.classList.remove("d-none-overlay");
        if (btnFilter) btnFilter.classList.add("actived");
      }
    });
  };

  // Colapsar acordeones y limpiar estado al cerrar el sidebar manualmente
  document.addEventListener("click", function (e) {
    const isSidebarClose = e.target.closest(".sidebar-close");
    const isOverlay = e.target.closest(".bls__overlay");
    const isBtnFilter = e.target.closest(".collection-filter .btn-filter");

    if (isSidebarClose || isOverlay) {
      openFilterNames = new Set();
      document.querySelectorAll(".filter-item").forEach(function (item) {
        const toggle = item.querySelector(".open-children-toggle");
        const content = item.querySelector(".filter-content");
        if (toggle) toggle.classList.remove("active");
        if (content) content.style.display = "none";
      });
    }

    if (isBtnFilter) {
      const sidebar = document.querySelector("#CollectionSidebar");
      if (sidebar && sidebar.classList.contains("bls__opend-popup")) {
        openFilterNames = new Set();
        document.querySelectorAll(".filter-item").forEach(function (item) {
          const toggle = item.querySelector(".open-children-toggle");
          const content = item.querySelector(".filter-content");
          if (toggle) toggle.classList.remove("active");
          if (content) content.style.display = "none";
        });
      }
    }
  }, true);

  // Patch principal — mantener sidebar y acordeones abiertos al filtrar
  const originalRender = BlsEventCollectionShopify.renderSectionFilter.bind(BlsEventCollectionShopify);

  BlsEventCollectionShopify.renderSectionFilter = function (e, t) {
    const sidebar = document.querySelector("#CollectionSidebar");
    const wasOpen = sidebar && sidebar.classList.contains("bls__opend-popup");

    if (!wasOpen) {
      return originalRender(e, t);
    }

    // Capturar categorías abiertas por nombre
    openFilterNames = new Set();
    document.querySelectorAll(".filter-item").forEach(function (item) {
      const toggle = item.querySelector(".open-children-toggle");
      const label = item.querySelector(".filter-title span, .filter-title label, .filter-title");
      if (toggle && toggle.classList.contains("active") && label) {
        openFilterNames.add(label.textContent.trim());
      }
    });

    const sidebarScrollTop = sidebar ? sidebar.scrollTop : 0;

    blsIsRendering = true;

    BlsEventCollectionShopify.toggleLoading(document.body, true);

    fetch(e)
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then(function (html) {
        const parsed = new DOMParser().parseFromString(html, "text/html");
        const newSection = parsed.querySelector(".section-collection-product");
        const currentSection = document.querySelector(".section-collection-product");

        if (newSection && currentSection) {
          currentSection.replaceWith(newSection);
        }

        BlsEventCollectionShopify.toggleLoading(document.body, false);
      })
      .catch(function (err) {
        blsIsRendering = false;
        throw err;
      })
      .finally(function () {
        if (typeof BlsReloadSpr !== "undefined") BlsReloadSpr.init();
        BlsEventCollectionShopify.init();
        if (typeof BlsColorSwatchesShopify !== "undefined") BlsColorSwatchesShopify.init();
        if (typeof BlsSubActionProduct !== "undefined") BlsSubActionProduct.init();
        setTimeout(function () {
          if (typeof BlsLazyloadImg !== "undefined") BlsLazyloadImg.init();
        }, 200);

        var savedNames = new Set(openFilterNames);
        var savedScroll = sidebarScrollTop;

        setTimeout(function () {
          blsIsRendering = false;

          const overlay = document.querySelector(".bls__overlay");
          const btnFilter = document.querySelector(".collection-filter .btn-filter");
          const newSidebar = document.querySelector("#CollectionSidebar");

          if (newSidebar) newSidebar.classList.add("bls__opend-popup");
          document.documentElement.classList.add("hside_opened");
          if (overlay) overlay.classList.remove("d-none-overlay");
          if (btnFilter) btnFilter.classList.add("actived");

          // Restaurar acordeones abiertos
          if (openFilterNames.size > 0) {
            document.querySelectorAll(".filter-item").forEach(function (item) {
              const toggle = item.querySelector(".open-children-toggle");
              const content = item.querySelector(".filter-content");
              const label = item.querySelector(".filter-title span, .filter-title label, .filter-title");

              if (!toggle || !content || !label) return;

              const name = label.textContent.trim();

              if (savedNames.has(name)) {
                toggle.classList.add("active");
                content.style.display = "block";
              } else {
                toggle.classList.remove("active");
                content.style.display = "none";
              }
            });
          }

          if (newSidebar) newSidebar.scrollTop = savedScroll;
        }, 100);
      });

    BlsEventCollectionShopify.updateUrl(e, t);
  };
})();
